// An open tab keeps its own organization, even when another tab changes it.
let initialized = false
export function isAssistanceToken(token: string | null) {
  try { return JSON.parse(atob((token || '').split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))).is_impersonation === true } catch { return false }
}
export function saveTabAuthToken(token: string) {
  initialized = true
  sessionStorage.setItem('authSessionInitialized', 'true')
  sessionStorage.setItem('authToken', token)
  try { sessionStorage.setItem('tokenExpiry', String(JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))).exp * 1000)) } catch { sessionStorage.removeItem('tokenExpiry') }
}
export function readAuthToken() {
  if (!initialized) {
    if (sessionStorage.getItem('authSessionInitialized') !== 'true') {
      for (const key of ['authToken', 'tokenExpiry']) {
        const value = localStorage.getItem(key)
        if (value) sessionStorage.setItem(key, value)
      }
      sessionStorage.setItem('authSessionInitialized', 'true')
    }
    initialized = true
  }
  return sessionStorage.getItem('authToken')
}
export function authProfileId() {
  const token = readAuthToken()
  try { return JSON.parse(atob((token || '').split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))).sub } catch { return undefined }
}
export function authContextKey() {
  const token = readAuthToken()
  try {
    const payload = JSON.parse(atob((token || '').split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))
    return `${payload.sub}:${payload.tenant_id}`
  } catch { return token }
}
export function saveAuthToken(token: string, expiresIn?: number) {
  let expiry = Date.now() + (Number.isFinite(Number(expiresIn)) ? Number(expiresIn) : 3600) * 1000
  try { expiry = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))).exp * 1000 || expiry } catch { /* Opaque tokens in tests. */ }
  initialized = true
  sessionStorage.setItem('authSessionInitialized', 'true')
  for (const storage of [sessionStorage, localStorage]) {
    storage.setItem('authToken', token)
    storage.setItem('tokenExpiry', String(expiry))
  }
}
export function clearAuthToken() {
  const token = readAuthToken()
  if (localStorage.getItem('authToken') === token) {
    localStorage.removeItem('authToken'); localStorage.removeItem('tokenExpiry')
  }
  clearTabAuthToken()
}
export function clearTabAuthToken() {
  readAuthToken()
  sessionStorage.removeItem('authToken'); sessionStorage.removeItem('tokenExpiry')
}
